import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Components
import Drawer from '../Drawer/Drawer';
// import Paginate from '../Common/Paginate';
import * as icons from '../Icons/Icons';

// Dependencies
import moment from 'moment';

const SupportTickets = observer(class SupportTickets extends React.Component {
  constructor() {
    super();
    this.handleDrawer = this.handleDrawer.bind(this);
    this.filterTickets = this.filterTickets.bind(this);
  }

  componentWillMount() {
    const { SessionStore, TicketStore} = this.props.store;

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      dataReceived: false
    };
    TicketStore.getTickets(SessionStore.userData.enrollmentSid);
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;

    if(pathname.indexOf('/view') > -1) {
      toggleDrawer(null, this, 'SupportTicketDetail');
    } else if(pathname.indexOf('/add') > -1) {
      toggleDrawer(null, this, 'AddSupportTicket');
    }
  }

  componentDidUpdate() {
    const { SessionStore, TicketStore } = this.props.store;

    // Set the state’s filtered tickets to all the tickets received from the API
    // then set the state dataReceived to true to prevent this from running again
    if(!SessionStore.loading && !this.state.dataReceived) {
      this.setState({
        filteredTickets: TicketStore.tickets,
        dataReceived: true
      });
    }
  }

  handleDrawer(e) {
    e.preventDefault();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.push(path);
    }
  }

  filterTickets() {
    const _this = this;
    const { tickets } = this.props.store.TicketStore;

    if(this.filter.value) {
      const newFilteredTickets = tickets.filter(function(key){
        return key.statusId.toString() === _this.filter.value;
      });

      this.setState({
        filter: this.filter.value
      });

      this.props.store.TicketStore.filterTickets(newFilteredTickets);
    } else {
      this.setState({
        filter: null
      })

      this.props.store.TicketStore.filterTickets(tickets);
    }
  }

  renderResults() {
    const { translation } = this.props;
    const { TicketStore } = this.props.store;
    const { filteredTickets } = TicketStore;
    const { userTimezone } = this.props.store.SessionStore;
    const segment1 = getURLSegment(this, 1);

    if(filteredTickets.length > 0) {
      // const paginate = {
      //   total: 10,
      //   first: '#',
      //   next: '#',
      //   prev: '#',
      //   last: '#',
      //   count: 1,
      //   limit: 1,
      //   current: 1
      // }

      return (
        <div>
          <table>
            <thead>
              <tr>
                <th scope="col" className="subtitle">{translation.ticket_id}</th>
                <th scope="col" className="subtitle">{translation.subject}</th>
                <th scope="col" className="subtitle">{translation.status}</th>
                <th scope="col" className="subtitle">{translation.last_update}</th>
              </tr>
            </thead>
            <tbody>
              {filteredTickets.map(
                (key, i) =>
                <tr key={i}>
                  <td>
                    <Link className="title-link--alt" to={`${segment1}/view/${key.sid}`} onClick={(e) => {this.handleDrawer(e)}}>
                      {key.ticketNumber}
                    </Link>
                  </td>
                  <td>
                    <Link className="title-link--alt" to={`${segment1}/view/${key.sid}`} onClick={(e) => {this.handleDrawer(e)}}>
                      {key.subject}
                    </Link>
                  </td>
                  <td><span className={`pill pill--${key.status.toLowerCase()}`}>{key.status}</span></td>
                  <td>{moment.utc(key.ticketLastUpdated).tz(userTimezone).format('M/D/YYYY h:mma')}</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* <Paginate paginate={paginate} {...this.props} /> */}
        </div>
      )
    } else {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }
  }

  render() {
    const { translation } = this.props;
    const segment1 = getURLSegment(this, 1);

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <div className="page__actions actions">
              <Link to={`${segment1}/add`} className="btn--outline" onClick={(e) => {this.handleDrawer(e)}}>
                <icons.iconPlus />
                {translation.button}
              </Link>
            </div>
          </div>
        </header>

        <form className="filter">
          <div className="wrap">
            <fieldset className="filter__filters">
              <ul className="fields fields--inline">
                <li><legend>{translation.show}:</legend></li>

                <li>
                  <label className="select">
                    <select onChange={this.filterTickets} ref={(input) => {this.filter = input}}>
                      <option value="">{translation.filters.all}</option>
                      <option value="2">{translation.filters.open}</option>
                      <option value="4">{translation.filters.resolved}</option>
                      <option value="5">{translation.filters.closed}</option>
                      <option value="3">{translation.filters.pending}</option>
                    </select>
                  </label>
                </li>
              </ul>
            </fieldset>
          </div>
        </form>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Drawer content={this.state.drawerContent} isOpen={this.state.drawerOpen} parent={this} {...this.props} />
      </main>
    )
  }
})

export default translate('SupportTickets')(SupportTickets);


// WEBPACK FOOTER //
// ./src/app/components/SupportTickets/SupportTickets.js